import * as dateUtils from '@ustra/core/src/utils/date-utils'

export default (value, format = 'yyyy-MM-dd'): string => {
  if (typeof value !== 'number' && !dateUtils.isDate(value)) {
    return value
  }

  return dateUtils.format(value, format)
}
